'use client';

import { FC, useEffect } from 'react';
import { motion, stagger, useAnimate } from 'framer-motion';
import { cn } from '@/lib/utils';

interface TextGenerateEffectProps {
  words: string;
  className?: string;
  filter?: boolean;
  duration?: number;
  highlightFormIndex?: number;
  highlightTextClassName?: string;
}

export const TextGenerateEffect: FC<TextGenerateEffectProps> = ({
  words,
  className,
  filter = true,
  duration = 0.5,
  highlightFormIndex = 3,
  highlightTextClassName,
}) => {
  const [scope, animate] = useAnimate();

  const wordsArray = words.split(' ');
  useEffect(() => {
    animate(
      'span',
      {
        opacity: 1,
        filter: filter ? 'blur(0px)' : 'none',
      },
      {
        duration: duration || 1,
        delay: stagger(0.2),
      },
    );
  }, [animate, duration, filter]);

  const renderWords = () => {
    return (
      <motion.div ref={scope}>
        {wordsArray.map((word, idx) => {
          return (
            <motion.span
              key={word + idx}
              className={cn('opacity-0', idx > highlightFormIndex ? 'text-purple' : 'dark:text-white text-black', highlightTextClassName)}
              style={{
                filter: filter ? 'blur(10px)' : 'none',
              }}
            >
              {word}
              {' '}
            </motion.span>
          );
        })}
      </motion.div>
    );
  };

  return (
    <div className={cn('font-bold', className)}>
      <div className="my-4">
        <div className=" dark:text-white text-black leading-snug tracking-wide">
          {renderWords()}
        </div>
      </div>
    </div>
  );
};
